// extracted by mini-css-extract-plugin
module.exports = {"Loader":"Spinner_Loader__115b4","load3":"Spinner_load3__15xjV"};